var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.79.12-.708.67a.392.392 0 0 0 0 .575l5.54 5.254H.43A.418.418 0 0 0 0 7.026v.948c0 .225.192.407.429.407h12.194l-5.54 5.254a.392.392 0 0 0 0 .575l.706.671a.445.445 0 0 0 .606 0l7.48-7.094a.392.392 0 0 0 0-.574L8.394.119a.445.445 0 0 0-.606 0Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhite);
export default __webpack_public_path__ + "static/media/arrow-right-white.81127ece7c4da1753564770d40d71535.svg";
export { ForwardRef as ReactComponent };